import React, { useState } from "react";
import Modal from "../ModalTemplate";
import Button from "../Button";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import { easterData } from "@pages/EasterEggPage/data";
import { fetchData } from "@app/Helpers";
import { useNavigate } from "react-router";
import { getUserDetails } from "@api/consumer";
import { getActivationList } from "@api/activation";
import { useQuery } from "@tanstack/react-query";
import icon from "./img/icon.png";
import iconFound from "./img/iconfound.png";
import bonus from "./img/bonus.png";
import bonusFound from "./img/bonusfound.png";

export default NiceModal.create(() => {
  const modal = useModal();
  const ident = modal.args?.ident;
  const isLastEgg = modal.args?.isLastEgg;
  const actualPoints = modal.args?.actualPoints;
  const easterItem = easterData[ident] || null;
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const passport = JSON.parse(sessionStorage.getItem("passportData")) || {};

  const detailsQuery = useQuery({
    queryKey: ["user-details"],
    queryFn: () => getUserDetails(),
  });

  const activationListQuery = useQuery({
    queryKey: ["activation-list"],
    queryFn: () => getActivationList(),
  });

  const updatePassportData = (callback) => {
    fetchData({
      endpoint: "/activation/passport/halloween2025/stats",
      payload: null,
      successCallback: (resObj) => {
        if (resObj.data?.passport) {
          sessionStorage.setItem(
            "passportData",
            JSON.stringify(resObj.data.passport)
          );
          window.dispatchEvent(new Event("passportUpdated"));
        }
        if (callback) callback();
      },
      errorCallback: () => setIsSubmitting(false),
    });
  };

  const resolveQuiz = (isLastEggParam) => {
    if (isLastEggParam === true) {
      fetchData({
        endpoint: "/activation/solution/create",
        payload: {
          activation: {
            ident: "halloween2025",
            payload: [
              {
                question_ident: "q0",
                answer_ident: null,
              },
            ],
          },
        },
        successCallback: () => {
          detailsQuery.refetch();
          activationListQuery.refetch();
        },
      });
    }
  };

  const ResolveEgg = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    fetchData({
      endpoint: "/activation/passport/halloween2025/solution",
      payload: {
        activation: {
          ident,
          payload: [
            {
              question_ident: "q0",
              answer_ident: null,
            },
          ],
        },
      },
      successCallback: () => {
        updatePassportData(() => {
          resolveQuiz(isLastEgg);
          detailsQuery.refetch();
          activationListQuery.refetch();
          modal.hide();
          setTimeout(() => navigate("/"), 300);
        });
      },
      errorCallback: () => setIsSubmitting(false),
    });
  };

  const haveAllEggs = React.useMemo(() => {
    const activation = passport.activation || {};
    const allEggs = Object.values(activation);
    if (allEggs.length === 0) return false;
    return allEggs.every((egg) => egg.resolved === true);
  }, [passport]);

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => modal.hide()}
      onAfterClose={() => modal.remove()}
      innerClass="easter-egg-modal"
    >
      <div className="crac-wrapper">
        <p className="title">
          Starker Fang!
          <br />
          Du hast{" "}
          <strong>
            {isLastEgg ? actualPoints : easterItem.payout} Punkte{" "}
          </strong>
          gesammelt.
        </p>
        <p className="score">Gefangene Kürbisse:</p>
        <div className="eggs-list-modal">
          {Array.from({ length: 7 }).map((_, index) => {
            const eggIdent = `halloween2025_${index + 1}`;
            const eggData = passport.activation?.[eggIdent] || {};

            const statusClass = eggData.resolved
              ? "egg-resolved"
              : eggData.found
              ? "egg-found"
              : "egg-unfound";

            const formatDate = (dayStr) => {
              if (!dayStr) return "";
              const date = new Date(dayStr);
              const day = date.getDate().toString().padStart(2, "0");
              const month = (date.getMonth() + 1).toString().padStart(2, "0");
              return `${day}.${month}`;
            };

            const dateLabel = formatDate(eggData.day);

            return (
              <div key={eggIdent} className={`egg-item ${statusClass}`}>
                <img
                  src={eggData.resolved ? iconFound : icon}
                  alt={eggIdent}
                  className="egg-icon"
                  style={{
                    opacity: eggData.found ? 1 : 0.5,
                  }}
                />
                <p className={`egg-date ${statusClass}`}>{dateLabel}</p>
              </div>
            );
          })}

          <img
            alt="bonus"
            src={haveAllEggs ? bonusFound : bonus}
            className="bonus"
          />
        </div>

        {!isLastEgg && (
          <p className="instruction">
            Es findet täglich um <strong>14:00</strong> Uhr statt.
          </p>
        )}

        <div className="btn-wrapper">
          <Button
            disabled={isSubmitting}
            action={() => {
              if (!passport.activation?.[ident]?.resolved) {
                ResolveEgg();
              } else {
                modal.hide();
                setTimeout(() => navigate("/"), 300);
              }
            }}
          >
            Zur nächste Aktivität
          </Button>
        </div>
      </div>
    </Modal>
  );
});
